import React from "react";
import { Row, Col } from "antd";
import styles from "./dataDisplay.module.css";

type TProps = {
  heading: string;
  content?: string;
  valueRender?: () => JSX.Element;
};

const RowDisplay: React.FC<TProps> = ({ heading, content, valueRender }) => {
  return (
    <Row style={{ marginBottom: "16px" }}>
      <Col
        span={10}
        style={{
          textAlign: "left",
          paddingRight: "8px",
        }}
      >
        <span className={styles.customHeading}>{heading}</span>
      </Col>
      <Col
        span={14}
        style={{
          textAlign: "right",
          wordWrap: "break-word",
          overflowWrap: "break-word",
        }}
      >
        <span className={styles.customContent}>
          {valueRender ? valueRender() : content}
        </span>
      </Col>
    </Row>
  );
};

export default RowDisplay;
